import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuardService {

  constructor(private route: Router, private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {

    // if (this.service.isloggedIn) {
    //   return true
    // } else {
    //   this.route.navigate(['/login'])
    //   return false
    // }

    return this.authService.isLoggedIn.pipe(
      take(1),
      map((isLoggedIn: boolean) => {
        console.log(isLoggedIn)
        if (isLoggedIn) {
          return true
        } else {
          this.route.navigate(['/login'])
          return false;
        }
      })
    )


  }



}
